import { ColDef } from 'ag-grid-community';
import type { TabsProps } from 'antd';
import { Tabs } from 'antd';
import React from 'react';
import '../../../style.scss';

import { IDataFilterGroupList, IInforAddGroup, IPagination, ISelectedCustomer } from '../AddNewGroup';
import AG_Decentralization, { ISelectedUserAccount } from './AG_Decentralization';
import AG_PrivateNoAutomatic from './AG_PrivateNoAutomatic';



interface props {
    memoizedColumnDefs: ColDef<any, any>[];
    paginationCustomers: IPagination;

    inforAddGroup: IInforAddGroup
    selectedIdCustomerV9: ISelectedCustomer[]
    selectedIdAccount: ISelectedUserAccount[]

    listCustomerNoAutomatic: any[];

    setSelectedIdCustomerV9: React.Dispatch<React.SetStateAction<ISelectedCustomer[]>>
    setSelectedIdAccount: React.Dispatch<React.SetStateAction<ISelectedUserAccount[]>>

    onPaginationCustomers: (page: number, pageSize: number) => void;

    //Kh không dk
    dataFilterListNoCondCustomers: IDataFilterGroupList;
    setDataFilterListNoCondCustomers: (dataFilterListNoCondCustomers: IDataFilterGroupList) => void;
    //Kh không dk

}


const AG_SharingNoAutomatic: React.FC<props> = ({
    memoizedColumnDefs,
    paginationCustomers,

    listCustomerNoAutomatic,

    inforAddGroup,
    selectedIdCustomerV9,
    selectedIdAccount,

    setSelectedIdCustomerV9,
    setSelectedIdAccount,

    onPaginationCustomers,

    //Kh không dk
    dataFilterListNoCondCustomers,
    setDataFilterListNoCondCustomers,
    //Kh không dk
}) => {

    const items: TabsProps['items'] = [
        {
            key: '1',
            label: <span className='custom-page-css text-base font-regular'>Danh sách khách hàng</span>,
            children:
                <AG_PrivateNoAutomatic
                    memoizedColumnDefs={memoizedColumnDefs}
                    paginationCustomers={paginationCustomers}

                    listCustomerNoAutomatic={listCustomerNoAutomatic}

                    inforAddGroup={inforAddGroup}
                    selectedIdCustomerV9={selectedIdCustomerV9}

                    setSelectedIdCustomerV9={setSelectedIdCustomerV9}

                    onPaginationCustomers={onPaginationCustomers}

                    //Kh không dk
                    dataFilterListNoCondCustomers={dataFilterListNoCondCustomers}
                    setDataFilterListNoCondCustomers={setDataFilterListNoCondCustomers}
                //Kh không dk


                />,
        },
        {
            key: '2',
            label: <span className='custom-page-css text-base font-regular'>Phân quyền</span>,
            children:
                <AG_Decentralization
                    inforAddGroup={inforAddGroup}
                    selectedIdAccount={selectedIdAccount}
                    setSelectedIdAccount={setSelectedIdAccount}
                />,
        },
    ];

    const onChange = (key: string) => {
        // console.log(key);
    };

    return (
        <div className="custom-page-css w-full flex flex-col gap-2 bg-white p-4 rounded">
            <div className="custom-page-css w-full flex gap-2 items-center">
                <Tabs defaultActiveKey="1" items={items} onChange={onChange} className='w-full' />

            </div>

        </div>
    )
}

export default React.memo(AG_SharingNoAutomatic)
